import axios from 'axios';

const loadNewsByCategory = () => {
    const categorySelect = document.querySelector('#newscat-select');

    if (typeof categorySelect !== 'undefined' && categorySelect !== null) {
        categorySelect.addEventListener('change', () => {
            const newsList = document.querySelector('.newsoverview');
            const loadMoreNewsButton = document.querySelector('#loadMoreNews');
            let newsCategory = categorySelect.options[categorySelect.selectedIndex].value;

            let params = new URLSearchParams();
            params.append('action', 'load_news_by_category');
            params.append('category_name', newsCategory);

            axios
                .post('/wp/wp-admin/admin-ajax.php', params)
                .then(res => {
                    let newcontainer = newsList.querySelector('.newslistitems__container');
                    newcontainer.innerHTML = '';
                    newcontainer.innerHTML += res.data.data.articles;
                    newsList.dataset.page = 1;
                    newsList.dataset.maxpages = res.data.data.maxnumpages;

                    let getUrl = window.location;
                    let baseUrl = getUrl.protocol + "//" + getUrl.host;
                    window.history.pushState({path: baseUrl + window.location.pathname}, '', baseUrl + window.location.pathname);

                    if (typeof loadMoreNewsButton !== 'undefined' && loadMoreNewsButton !== null) {
                        if (parseInt(newsList.dataset.page) >= parseInt(newsList.dataset.maxpages)) {
                            loadMoreNewsButton.classList.add('hidden');
                            loadMoreNewsButton.disabled = true;
                        } else {
                            loadMoreNewsButton.classList.remove('hidden');
                            loadMoreNewsButton.disabled = false;
                        }
                    }
                });
        });
    }
}

export default loadNewsByCategory;
